import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EPaymentMethodsState, IPaymentMethodsSettings } from '../types/payment-methods.type';

interface PaymentMethodsInitialState {
  isLoading: boolean;
  manualPaymentState: EPaymentMethodsState;
  paymentSettings: IPaymentMethodsSettings | null;
}

const paymentMethodsInitialState: PaymentMethodsInitialState = {
  isLoading: false,
  manualPaymentState: EPaymentMethodsState.INIT,
  paymentSettings: null,
};

export const paymentMethods = createSlice({
  name: 'paymentMethods',
  initialState: paymentMethodsInitialState,
  reducers: {
    setManualPaymentState: (state, action: PayloadAction<EPaymentMethodsState>) => {
      state.manualPaymentState = action.payload;
    },
    setPaymentSettings: (state, action: PayloadAction<IPaymentMethodsSettings | null>) => {
      state.paymentSettings = action.payload;
    },
    setIsManualPaymentLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setManualPaymentState, setPaymentSettings, setIsManualPaymentLoading } = paymentMethods.actions;
